/*
 * Built with Common Launchpad 4.0.2
 */

import $ from 'jquery';
import modaal from 'modaal';

class Modal {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
		$('.js-inline-modal').modaal();

		$('.js-internal-video').modaal({
			type: 'inline',
			custom_class: 'modaal-video',
			width: 930
		});

		$('.js-video').modaal({
			type: 'video',
			width: 930
		});

		$('.image-modal').modaal({
			type: 'image',
			width: 930
		});
		
		// Close when clicking Modaal overlay
		$(document).on('click', (e) => {
			if ($(e.target).hasClass('modaal-outer-wrapper')) {
				$('.image-modal, .js-video, .js-inline-modal').modaal('close');
			}
		});
    }
}

export default Modal;

$(() => {
	const modal = new Modal();
	modal.init();
});
